export default __webpack_public_path__ + "static/media/not-allowed-icon.331d4a5d.svg";